import { cloneJson } from "../Common/CloneCommon";
import moment from "moment";
import axios from 'axios';
import { dispatch } from "../App";
import { SnackbarOpen } from "../Reducer/SnackBarReducer/SnackBarSlice";
import { AuthLogout } from "../Reducer/AuthReducer/AuthSlice";

const host = '/api';
const routeApi = {

    default: '/',

    // AUTH
    authentication_login: '/authentication/login',
    authentication_logout: '/authentication/logout',
    authentication_register: '/authentication/register',

    // ADMINISTRATOR
    administrator_user_list: '/administrator/user/list',
    administrator_user_add: '/administrator/user/add',
    administrator_user_edit: '/administrator/user/{id}',
    administrator_user_get: '/administrator/user/{id}',
    administrator_user_delete: '/administrator/user/{id}',

    administrator_role_list: '/administrator/role/list',
    administrator_role_add: '/administrator/role/add',
    administrator_role_edit: '/administrator/role/{id}',
    administrator_role_delete: '/administrator/role/{id}',
    administrator_mail_log_list: '/administrator/log/mail/list',
    administrator_cron_log_list: '/administrator/log/cron/list',

    configuration_prestation_list: '/configuration/prestation/list',
    configuration_prestation_get: '/configuration/prestation/{id}',
    configuration_prestation_edit: '/configuration/prestation/{id}',
    configuration_prestation_add: '/configuration/prestation/add',
    configuration_prestation_delete: '/configuration/prestation/{id}',

    configuration_prestation_group_list: '/configuration/prestation-group/list',
    configuration_prestation_group_get: '/configuration/prestation-group/{id}',
    configuration_prestation_group_edit: '/configuration/prestation-group/{id}',
    configuration_prestation_group_add: '/configuration/prestation-group/add',
    configuration_prestation_group_delete: '/configuration/prestation-group/{id}',

    configuration_product_list: '/configuration/product/list',
    configuration_product_get: '/configuration/product/{id}',
    configuration_product_edit: '/configuration/product/{id}',
    configuration_product_add: '/configuration/product/add',
    configuration_product_delete: '/configuration/product/{id}',

    configuration_availability_list: '/configuration/availability/list',
    configuration_availability_get: '/configuration/availability/{id}',
    configuration_availability_edit: '/configuration/availability/{id}',
    configuration_availability_add: '/configuration/availability/add',
    configuration_availability_delete: '/configuration/availability/{id}',

    
    // CRM
    crm_customer_list: '/crm/customer/list',
    crm_customer_get: '/crm/customer/{id}',
    crm_customer_edit: '/crm/customer/{id}',
    crm_customer_add: '/crm/customer/add',
    crm_customer_delete: '/crm/customer/{id}',
    crm_customer_purchase_list: '/crm/customer/{id}/purchase/list',
    crm_customer_purchase_select: '/crm/customer/{id}/purchase/select',
    crm_customer_purchase_add: '/crm/customer/{id}/purchase/add',
    crm_customer_purchase_edit: '/crm/customer/{id}/purchase/{purchaseId}',
    crm_customer_purchase_delete: '/crm/customer/{id}/purchase/{purchaseId}',

    crm_appointment_list: '/crm/appointment/list',
    crm_appointment_get: '/crm/appointment/{id}',
    crm_appointment_edit: '/crm/appointment/{id}',
    crm_appointment_add: '/crm/appointment/add',
    crm_appointment_delete: '/crm/appointment/{id}',
    crm_appointment_select: '/crm/appointment/select',
    crm_appointment_slots: '/crm/appointment/slots',
    crm_appointment_closure_add: '/crm/appointment/closure/add',
    crm_appointment_closure_delete: '/crm/appointment/closure/{id}',
    crm_appointment_opening_add: '/crm/appointment/opening/add',
    crm_appointment_opening_delete: '/crm/appointment/opening/{id}',
    crm_appointment_notification_count: '/crm/appointment/notification/count',
    crm_appointment_notification_latest: '/crm/appointment/notification/latest',
    crm_appointment_notification_read: '/crm/appointment/notification/read',

    // SELECT
    select_role: '/select/role',

    // PUBLIC CATALOGUE
    public_catalogue_prestations_list: '/public/catalogue/prestations',
    public_catalogue_prestation_get: '/public/catalogue/prestations/{id}',

    // PUBLIC APPOINTMENT
    public_appointment_captcha_config: '/public/appointment/captcha-config',
    public_appointment_select: '/public/appointment/select',
    public_appointment_first_appointment_benefits: '/public/appointment/first-appointment-benefits',
    public_appointment_slots: '/public/appointment/slots',
    public_appointment_add: '/public/appointment/add',
};

const cacheConfig = {
    /*
        Exemple
        api_select_users: 14400,
    */
};

class ApiHandler {
    constructor() {
        let cache = {};

        this.host = function () {
            return window.location.protocol + '//' + window.location.host;
        };
        this.route = function (options) {
            let route = routeApi[options.route];

            if (!route) {
                console.log(options.route);
                console.log(route);
                dispatch(
                    SnackbarOpen({
                        text: 'Route introuvable (ApiHandler.js)',
                        variant: 'error',
                    })
                );
                return;
            }

            if (options.data) {
                route += '?';
                for (let index in options.data) {
                    let dataGet = options.data[index] === null ? '' : options.data[index];
                    dataGet = dataGet === undefined ? '' : dataGet;

                    if (Array.isArray(dataGet)) {
                        for (let index1 in dataGet) {
                            route += index + "[]=" + dataGet[index1] + "&";
                        }
                    }
                    else {
                        if (dataGet || dataGet === false) route += index + "=" + dataGet + "&";
                    }
                }
                route = route.slice(0, -1);
            }

            for (let key in options.params) {
                let regEx = new RegExp('{' + key + '}', 'gi');
                route = route.replace(regEx, options.params[key]);
            }

            return host + route;
        };
        this.get = function (options, callback) {
            let route = routeApi[options.route];

            if (!route) {
                callback({ status: 404 });
                console.log(options.route);
                console.log(route);
                dispatch(
                    SnackbarOpen({
                        text: 'Route introuvable (ApiHandler.js)',
                        variant: 'error',
                    })
                );
                return;
            }

            if (options.data) {
                route += '?';
                for (let index in options.data) {
                    let dataGet = options.data[index] === null ? '' : options.data[index];
                    dataGet = dataGet === undefined ? '' : dataGet;

                    if (Array.isArray(dataGet)) {
                        for (let index1 in dataGet) {
                            route += index + "[]=" + dataGet[index1] + "&";
                        }
                    }
                    else {
                        if (dataGet || dataGet === 0 || dataGet === false) route += index + "=" + dataGet + "&";
                    }
                }
                route = route.slice(0, -1);
            }

            for (let key in options.params) {
                let regEx = new RegExp('{' + key + '}', 'gi');
                route = route.replace(regEx, options.params[key]);
            }

            if (cache[route] && cache[route].age.isAfter(moment())) {
                let data = cloneJson(cache[route].data);
                callback(data);
            }
            else {
                axios.get(host + route, { withCredentials: true })
                    .then(function (response) {
                        if (cacheConfig[options.route]) {
                            if (options.route in cacheConfig) {
                                cache[route] = {
                                    data: cloneJson(response.data),
                                    age: moment().add(cacheConfig[options.route], 's'),
                                };
                                callback(cloneJson(response.data));
                            }
                        }
                        else {
                            callback(response.data);
                        }
                    })
                    .catch(err => {
                        console.log(options.route);
                        console.log(route);
                        console.log(err);
                        if (err.response.status === 401) {
                            console.log('err 401');
                            dispatch(AuthLogout());
                        }
                        else {
                            if (err.response.data.status === 403 && err.response.data.error.message) {
                                dispatch(
                                    SnackbarOpen({
                                        text: err.response.data.error.message,
                                        variant: 'error',
                                    })
                                );
                            }
                            callback(err.response.data);
                        }
                    });
            }
        };
        this.post = function (options, callback) {
            let route = routeApi[options.route];

            if (!route) {
                callback({ status: 404 });
                console.log(options.route);
                console.log(route);
                dispatch(
                    SnackbarOpen({
                        text: 'Route introuvable (ApiHandler.js)',
                        variant: 'error',
                    })
                );
                return;
            }

            for (let key in options.params) {
                let regEx = new RegExp('{' + key + '}', 'gi');
                route = route.replace(regEx, options.params[key]);
            }

            let data;
            if (options.file) {
                data = new FormData();
                for (let property in options.file) {
                    const fileValue = options.file[property];
                    if (Array.isArray(fileValue)) {
                        for (let index in fileValue) {
                            data.append(property + "[]", fileValue[index]);
                        }
                    } else {
                        data.append(property, fileValue);
                    }
                }
                if (options.data) {
                    data.append('_json', JSON.stringify(options.data));
                }
            }
            else {
                data = JSON.stringify(options.data);
            }

            axios.post(host + route, data, { withCredentials: true })
                .then(function (response) {
                    callback(response.data);
                })
                .catch(err => {
                    console.log(route);
                    console.log(err);
                    if (err.response.status === 401) {
                        console.log('err 401');
                        dispatch(AuthLogout());
                    }
                    else {
                        if (err.response.data.status === 403 && err.response.data.error.message) {
                            dispatch(
                                SnackbarOpen({
                                    text: err.response.data.error.message,
                                    variant: 'error',
                                })
                            );
                        }
                        callback(err.response.data);
                    }
                });
        };
        this.delete = function (options, callback) {
            let route = routeApi[options.route];

            for (let key in options.params) {
                let regEx = new RegExp('{' + key + '}', 'gi');
                route = route.replace(regEx, options.params[key]);
            }

            axios.delete(host + route, { withCredentials: true })
                .then(function (response) {
                    callback(response.data);
                })
                .catch(err => {
                    console.log(route);
                    console.log(err);
                    if (err.response.status === 401) {
                        console.log('err 401');
                        dispatch(AuthLogout());
                    }
                    else {
                        if (err.response.data.status === 403 && err.response.data.error.message) {
                            dispatch(
                                SnackbarOpen({
                                    text: err.response.data.error.message,
                                    variant: 'error',
                                })
                            );
                        }
                        callback(err.response.data);
                    }
                });

        };
        this.postDownload = function (options, callback) {
            let route = routeApi[options.route];

            for (let key in options.params) {
                let regEx = new RegExp('{' + key + '}', 'gi');
                route = route.replace(regEx, options.params[key]);
            }

            let data;
            if (options.file) {
                data = new FormData();
                for (let property in options.file) {
                    const fileValue = options.file[property];
                    if (Array.isArray(fileValue)) {
                        for (let index in fileValue) {
                            data.append(property + "[]", fileValue[index]);
                        }
                    } else {
                        data.append(property, fileValue);
                    }
                }
                if (options.data) {
                    data.append('_json', JSON.stringify(options.data));
                }
            }
            else {
                data = JSON.stringify(options.data);
            }

            axios.post(host + route, data, { withCredentials: true, responseType: 'blob' })
                .then(response => new File([response.data], options.filename))
                .then(response => {
                    const url = window.URL.createObjectURL(response);
                    const a = document.createElement('a');
                    a.style.display = 'none';
                    a.href = url;
                    a.download = options.filename;
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(url);
                    callback({ status: 200 });
                })
                .catch(err => {
                    console.log(route);
                    console.log(err);
                    if (err.response.status === 401) {
                        console.log('err 401');
                        dispatch(AuthLogout());
                    }
                    else {
                        if (err.response.data.status === 403 && err.response.data.error.message) {
                            dispatch(
                                SnackbarOpen({
                                    text: err.response.data.error.message,
                                    variant: 'error',
                                })
                            );
                        }
                        callback(err.response.data);
                    }
                });
        };
        this.getDownload = function (options, callback) {
            let route = routeApi[options.route];

            if (!route) {
                callback({ status: 404 });
                console.log(options.route);
                console.log(route);
                dispatch(
                    SnackbarOpen({
                        text: '404',
                        variant: 'error',
                    })
                );
                return;
            }

            if (!options.data) {
                options.data = { download: 1 };
            }
            else {
                options.data.download = 1;
            }

            route += '?';
            for (let index in options.data) {
                let dataGet = options.data[index] === null ? '' : options.data[index];
                dataGet = dataGet === undefined ? '' : dataGet;

                if (Array.isArray(dataGet)) {
                    for (let index1 in dataGet) {
                        route += index + "[]=" + dataGet[index1] + "&";
                    }
                }
                else {
                    if (dataGet || dataGet === false) route += index + "=" + dataGet + "&";
                }
            }
            route = route.slice(0, -1);

            for (let key in options.params) {
                let regEx = new RegExp('{' + key + '}', 'gi');
                route = route.replace(regEx, options.params[key]);
            }

            axios.get(host + route, { withCredentials: true, responseType: 'blob' })
                .then(response => {
                    let attachment = response.headers["content-disposition"];
                    if (attachment) {
                        let split = attachment.split('"');
                        options.filename = split[1];
                    }
                    return new File([response.data], options.filename);
                })
                .then(response => {
                    const url = window.URL.createObjectURL(response);
                    const a = document.createElement('a');
                    a.style.display = 'none';
                    a.href = url;
                    a.download = options.filename;
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(url);
                    callback({ status: 200 });
                })
                .catch(err => {
                    console.log(route);
                    console.log(err);
                    if (err.response.status === 401) {
                        console.log('err 401');
                        dispatch(AuthLogout());
                    }
                    else {
                        if (err.response.data.status === 403 && err.response.data.error.message) {
                            dispatch(
                                SnackbarOpen({
                                    text: err.response.data.error.message,
                                    variant: 'error',
                                })
                            );
                        }
                        console.log(err.response.data);
                    }
                });
        };
        this.clearCache = function (index) {
            delete cache[routeApi[index]];
        };
    }
}

const api = new ApiHandler();

export default api;

export const shopManagerProductImageBanner = host + '/shop-manager/product/image/';
export const customerShopProductImage = host + '/customer/shop/product/image/';
export const mediaManagerPodcastImage = host + '/media-manager/podcast/image/';
export const customerPodcastImage = host + '/customer/podcast/image/';
